import React from 'react';
import ReactDOM from 'react-dom';
import * as d3 from 'd3';
import _ from 'lodash';

import { layoutBars } from './bar-layout';

function barFill(d) {
  return d.color || d.fill || null;
}

function createChart(dom, props) {
  const data = props.data;
  const { thickness, offsets } = layoutBars(props.height, data.length);

  const x = d3
    .scaleLinear()
    .domain([
      0,
      d3.max(
        _.map(data, (d) => {
          return d.count;
        })
      ),
    ])
    .range([0, props.width]);

  const chart = d3
    .select(dom)
    .append('svg')
    .attr('class', 'd3 horizontal-bar-chart')
    .attr('width', props.width)
    .attr('height', props.height)
    .attr('viewBox', '0 0 ' + props.width + ' ' + props.height)
    .attr('preserveAspectRatio', props.preserveAspectRatio);

  chart
    .selectAll('rect')
    .data(data)
    .enter()
    .append('svg:rect')
    .attr('transform', function (d, i) {
      return 'translate(0,' + offsets[i] + ')';
    })
    .attr('width', (d) => {
      return x(d.count);
    })
    .attr('class', (d) => {
      return d.className;
    })
    .attr('fill', barFill)
    .attr('height', thickness);

  chart
    .append('svg:line')
    .attr('x1', 0)
    .attr('x2', 0)
    .attr('y1', 0)
    .attr('y2', props.height)
    .attr('class', 'axis');

  return chart;
}

function updateChart(chart, props) {
  const data = props.data;

  const x = d3
    .scaleLinear()
    .domain([
      0,
      d3.max(
        _.map(data, (d) => {
          return d.count;
        })
      ),
    ])
    .range([0, props.width]);

  chart
    .selectAll('rect')
    .data(data)
    .transition()
    .duration(props.duration)
    .attr('width', (d) => {
      return x(d.count);
    })
    .attr('class', (d) => {
      return d.className;
    })
    .attr('fill', barFill);
}

class HorizontalBarChart extends React.Component {
  componentDidMount() {
    const dom = ReactDOM.findDOMNode(this);
    this.chart = createChart(dom, this.props);
  }

  shouldComponentUpdate(props) {
    // check the incoming props to see if we should update
    function isEqual(a, b, compareProps) {
      return _.isEqual(_.pick(a, compareProps), _.pick(b, compareProps));
    }

    if (!isEqual(this.props, props, ['data', 'yLimit', 'height'])) {
      updateChart(this.chart, props);
    }
    return false;
  }

  render() {
    return <div className="horizontal-bar-chart" />;
  }
}

HorizontalBarChart.defaultProps = {
  width: 100,
  // Same footprint as the original 3-bar tally: 30px step × 3 − 1px.
  height: 89,
  title: '',
  legend: true,
  data: [],
  labels: [],
  duration: 1000,
  preserveAspectRatio: 'none',
};

export default HorizontalBarChart;
